import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-brouillon-cmd',
  templateUrl: './brouillon-cmd.component.html',
  styleUrls: ['./brouillon-cmd.component.scss']
})
export class BrouillonCmdComponent implements OnInit {
    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        console.log('BrouillonCmdComponent initialized');
        this.dataService.filterOrdersByStatus('Brouillon');
    }
}
